import { render, staticRenderFns } from "./traveler-label.vue?vue&type=template&id=a72b66ba&scoped=true"
import script from "./traveler-label.vue?vue&type=script&lang=js"
export * from "./traveler-label.vue?vue&type=script&lang=js"
import style0 from "./traveler-label.vue?vue&type=style&index=0&id=a72b66ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72b66ba",
  null
  
)

export default component.exports